import { instance3 } from "App/constants";

export const urlGet = "/master/paket/ms_paket/list";
export const urlCreate = "/master/paket/ms_paket/add";
export const urlUpdate = "/master/paket/ms_paket/updateHarga";
export const urlDelete = "/master/paket/ms_paket/delete";
export const urlUpdateAll = "/master/paket/ms_paket/updateAll";
export const urlGetJenisPaket = "/master/paket/js_paket/list";
export const urlGetById = "/master/paket/ms_paket/detailsById";

export const RESET_STATE_PAKET = {
  id_jenis_paket: 1,
  id_tarif_cbg: null,
  tarif_cbg: "Pilih CBG",
  nama: "",

  gudang_id: null,
  gudang_name: "Pilih Gudang",

  harga: "",
  status: 1,
  isUpdate: false,
  barang: [],
  jasa: [],
  fasilitas: [],
  rikjang: [],
};

export const getPaketById = async (id, id_jenis_harga) => {
  try {
    const res = await instance3.post(`${urlGetById}`, {
      id: id,
      id_msHarga: id_jenis_harga,
    });
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data[0],
      };
    } else {
      return {
        state: false,
        message: res.sata.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePaketById = async (id) => {
  try {
    await instance3.post(
      urlDelete,
      {},
      {
        headers: {
          id: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
];

export const getDataTab = async (formFilter, pages, limit, url) => {
  try {
    const api = await instance3.post(url, {
      jumlah: limit,
      halaman: pages,
      nama: formFilter.nama,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
